import React, { PropsWithChildren } from "react";

type Props = {};

export const ExpandButton = (props: PropsWithChildren<Props>) => {
    const { children } = props;
    return <div className={"expandButton"}>{children}</div>;
};
